export enum ShelfType {
    REGULAR,
    HANGCELL,
    UNKNOWN
}